var _excluded = ["className", "error", "helperText", "hint", "loading", "onChange", "selectors", "value", "spinnerSize", "spinnerWidth"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React, { useRef } from 'react';
import uuid from 'short-uuid';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import FormControl, { ItemStyled, InputLabelStyled, SpinnerStyled } from './styles/SelectDropdownStyled';
import { SelectArrow } from '../../@theme/assets/svg/forms';
var SelectDropdown = function SelectDropdown(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    error = _ref.error,
    helperText = _ref.helperText,
    hint = _ref.hint,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    onChange = _ref.onChange,
    selectors = _ref.selectors,
    value = _ref.value,
    _ref$spinnerSize = _ref.spinnerSize,
    spinnerSize = _ref$spinnerSize === void 0 ? 28 : _ref$spinnerSize,
    _ref$spinnerWidth = _ref.spinnerWidth,
    spinnerWidth = _ref$spinnerWidth === void 0 ? 5 : _ref$spinnerWidth,
    props = _objectWithoutProperties(_ref, _excluded);
  var idRef = useRef(uuid.generate());
  var disabled = loading || props.disabled;
  return React.createElement(FormControl, {
    className: className,
    disabled: disabled,
    error: error,
    fullWidth: true
  }, loading && React.createElement(SpinnerStyled, {
    size: spinnerSize,
    width: spinnerWidth
  }), hint && React.createElement(InputLabelStyled, {
    id: "".concat(idRef.current, "-label")
  }, hint), React.createElement(Select, _extends({}, props, {
    disabled: disabled,
    id: idRef.current,
    IconComponent: SelectArrow,
    label: hint,
    labelId: "".concat(idRef.current, "-label"),
    onChange: onChange,
    value: value
  }), selectors.map(function (selectItem) {
    return React.createElement(ItemStyled, {
      key: JSON.stringify(selectItem.value),
      value: selectItem.value
    }, selectItem.label);
  })), helperText && React.createElement(FormHelperText, null, helperText));
};
export default SelectDropdown;